export const ACTIONS = {
    CMTSDATA: 'CMTSDATA',
    CONTENTCARDDATA: 'CONTENTCARDDATA',
    TAGS: 'TAGS',
    CONTENTSETTINGS: 'CONTENTSETTINGS',
    CONTENTTYPES: 'CONTENTTYPES',
    GROUPRADARID:'GROUPRADARID',
    GETRADARDATAACTION:'GETRADARDATAACTION',
    CURRENTINDEXEDITINGHISTORY: 'CURRENTINDEXEDITINGHISTORY',
    LANGFORTRANSSTATE: 'LANGFORTRANSSTATE',
    ISAUTOTRANS: 'ISAUTOTRANS',
    LANGLISTOPTIONS: 'LANGLISTOPTIONS',
    GETWHOLEHTMLCARD1: 'GETWHOLEHTMLCARD1',
    GETWHOLEHTMLCARD2: 'GETWHOLEHTMLCARD2',
    GETWHOLEHTMLCARD3: 'GETWHOLEHTMLCARD3',
    GETWHOLEHTMLCARD4: 'GETWHOLEHTMLCARD4',
    GETWHOLEHTMLCARD5: 'GETWHOLEHTMLCARD5',
    GETWHOLEHTMLCARD6: 'GETWHOLEHTMLCARD6',
    GETWHOLEHTMLCARD7: 'GETWHOLEHTMLCARD7',
    GETWHOLEHTMLCARD8: 'GETWHOLEHTMLCARD8',
    GETWHOLEHTMLCARD9: 'GETWHOLEHTMLCARD9',
    GETWHOLEHTMLCARD10: 'GETWHOLEHTMLCARD10',
    GETWHOLEHTMLCARD11: 'GETWHOLEHTMLCARD11',
    ISTRANSLATED: 'ISTRANSLATED',
    ISLOADING: 'ISLOADING'
}